import Lenis from '@studio-freight/lenis';
import * as bootstrap from "bootstrap";

gsap.registerPlugin(ScrollTrigger);

const lenis = new Lenis({
  duration: 1.2,
  easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t))
});

function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}

requestAnimationFrame(raf);

lenis.on('scroll', ScrollTrigger.update)

gsap.ticker.add((time) => {
  lenis.raf(time * 1000)
})

const scrollSpy = new bootstrap.ScrollSpy(document.body, {
  target: '#navbar-example',
  smoothScroll: true
})

const heroTitle = document.getElementById("pageTitle");
const heroH1 = heroTitle.querySelector("h1");
const heroH2 = heroTitle.querySelector("h2");

gsap.set(heroTitle, {
  scaleX: 0,
  transformOrigin: "left"
})

gsap.set(heroH1, {
  opacity: 0,
})

gsap.set(heroH2, {
  opacity: 0,
})

let htl = new gsap.timeline({
  delay: .75,
  easing: "sine"
});

htl.to(heroTitle, {
  scaleX: 1,
  duration: .5,
})
  .to(heroH1, {
    opacity: 1,
  })
  .to(heroH2, {
    opacity: 1,
  })

const paragraphs = document.querySelectorAll("p")

paragraphs.forEach(par => {
  gsap.set(par, { opacity: 0, y: "1rem" })
  gsap.to(par, {
    scrollTrigger: {
      trigger: par,
      start: "bottom bottom",
    },
    opacity: 1,
    y: 0,
    ease: "power4.ease"
  })
})